import React, { Fragment, useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { GET_ARTICULO, UPDATE_ARTICULO } from '../../graphql/actions/articulo';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import CustomInput from '../UI/CustomInput/CustomInput.js';
import Button from '../UI/CustomButtons/Button.js';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';
// Validations
import { isEmpty, countWords } from '../../util/validators';

import sectionAddStyle from '../../assets/jss/coscef/views/articuloSections/sectionAddStyle';

const useStyles = makeStyles(sectionAddStyle);
const editorConfiguration = {
  language: 'es',
};

const ArticuloEdt = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const [formTitulo, setFormTitulo] = useState('');
  const [formAutor, setFormAutor] = useState('');
  const [formDescripcionAutor, setFormDescripcionAutor] = useState('');
  const [formResumen, setFormResumen] = useState('');
  const [formEtiquetas, setFormEtiquetas] = useState('');
  const [edtForm, setEdtForm] = useState({
    titulo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    autor: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    descripcionAutor: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    resumen: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, countWords({ min: 30, max: 38 })],
    },
    contenido: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    etiquetas: {
      value: '',
      valid: true,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of edtForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'titulo') {
        if (isValid) setFormTitulo('success');
        else setFormTitulo('error');
      }
      if (input === 'autor') {
        if (isValid) setFormAutor('success');
        else setFormAutor('error');
      }
      if (input === 'descripcionAutor') {
        if (isValid) setFormDescripcionAutor('success');
        else setFormDescripcionAutor('error');
      }
      if (input === 'resumen') {
        if (isValid) setFormResumen('success');
        else setFormResumen('error');
      }
      if (input === 'etiquetas') {
        if (isValid) setFormEtiquetas('success');
        else setFormEtiquetas('error');
      }
    }

    const updatedForm = {
      ...edtForm,
      [input]: {
        ...edtForm[input],
        valid: isValid,
        value: value,
      },
    };

    let count = 6;
    let formIsValid = true;
    for (const inputName in updatedForm) {
      //formIsValid = formIsValid && updatedForm[inputName].valid;
      if (updatedForm[inputName].valid) count -= 1;
    }

    //console.log(count);
    if (count <= 4) formIsValid = true;
    else formIsValid = false;

    setEdtForm(updatedForm);
    setFormIsValid(formIsValid);
  };

  const redirectToArticulos = (data) => {
    //console.log(data);
    if (data.updateArticulo) props.history.push('/articulos');
    else console.log('Error editando articulo.');
  };

  const {
    loading: loadingArticulo,
    error: errorArticulo,
    data: dataArticulo,
  } = useQuery(GET_ARTICULO, {
    variables: {
      id: props.match.params.id,
    },
    skip: !props.match.params.id,
    errorPolicy: 'all',
  });

  const [
    editArticulo,
    {
      loading: loadingEdtArticulo,
      error: errorEdtArticulo,
      data: dataEdtArticulo,
    },
  ] = useMutation(UPDATE_ARTICULO, {
    errorPolicy: 'all',
    //update: updateCacheEdt,
    onCompleted: (data) => redirectToArticulos(data),
  });

  const editarHandler = (event) => {
    event.preventDefault();

    const articuloData = {};
    for (let i in edtForm) {
      if (edtForm[i].value === '') continue;
      else articuloData[i] = edtForm[i].value;
    }

    //console.log(articuloData);

    editArticulo({
      variables: {
        input: {
          id: props.match.params.id,
          titulo: articuloData.titulo,
          autor: articuloData.autor,
          descripcionAutor: articuloData.descripcionAutor,
          resumen: articuloData.resumen,
          contenido: articuloData.contenido,
          etiquetas: articuloData.etiquetas,
        },
      },
    });
  };

  let seccionTitulo = null;
  let seccionButton = null;
  let seccionFormulario = null;
  let showNotification = null;

  if (loadingArticulo) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />;
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = null;
    seccionFormulario = null;
  }
  if (loadingEdtArticulo) seccionButton = <Spinner color='gray' />;

  if (errorArticulo) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Error buscando el articulo.</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = null;
    seccionFormulario = null;

    showNotification = errorArticulo.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorArticulo ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorEdtArticulo) {
    showNotification = errorEdtArticulo.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorEdtArticulo ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataArticulo && dataArticulo.getArticulo) {
    const { getArticulo } = dataArticulo;
    //console.log(getArticulo);
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Editar Articulo</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = (
      <GridContainer>
        <GridItem
          md={4}
          sm={4}
          className={classNames(
            classes.mrAuto,
            classes.mlAuto,
            classes.textCenter
          )}
        >
          <Button type='submit' color='dark' round disabled={!formIsValid}>
            Editar Articulo
          </Button>
        </GridItem>
      </GridContainer>
    );

    seccionFormulario = (
      <div id='formularioEdt'>
        <GridContainer>
          <GridItem
            md={8}
            sm={8}
            className={classNames(classes.mrAuto, classes.mlAuto)}
          >
            <form onSubmit={editarHandler}>
              <GridContainer>
                <GridItem md={12} sm={12} key={getArticulo._id}>
                  <CustomInput
                    labelText='Título (*)'
                    success={formTitulo === 'success'}
                    error={formTitulo === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'titulo');
                      },
                      placeholder: getArticulo.titulo,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Autor (*)'
                    success={formAutor === 'success'}
                    error={formAutor === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'autor');
                      },
                      placeholder: getArticulo.autor,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Descripción del autor (*)'
                    success={formDescripcionAutor === 'success'}
                    error={formDescripcionAutor === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(
                          event.target.value,
                          'descripcionAutor'
                        );
                      },
                      multiline: true,
                      rows: 2,
                      placeholder: getArticulo.descripcionAutor,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Resumen (De 30 a 38 palabras)'
                    success={formResumen === 'success'}
                    error={formResumen === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'resumen');
                      },
                      multiline: true,
                      rows: 6,
                      placeholder: getArticulo.resumen,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <div className={classes.control}>
                    <p className={classes.label}>Contenido</p>
                    <CKEditor
                      //disabled={true}
                      editor={ClassicEditor}
                      data={getArticulo.contenido}
                      config={editorConfiguration}
                      onReady={(editor) => {
                        // You can store the "editor" and use when it is needed.
                        //console.log('Editor is ready to use!', editor);
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        inputChangedHandler(data, 'contenido');
                        //console.log({ event, editor, data });
                      }}
                    />
                  </div>
                </GridItem>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Etiquetas (De 2 a 3 palabras)'
                    success={formEtiquetas === 'success'}
                    error={formEtiquetas === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'etiquetas');
                      },
                      placeholder: getArticulo.etiquetas,
                    }}
                  />
                </GridItem>
              </GridContainer>
              {seccionButton}
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (dataEdtArticulo && dataEdtArticulo.updateArticulo) {
    const { updateArticulo } = dataEdtArticulo;
    if (updateArticulo.success && updateArticulo.code === '201') {
      showNotification = (
        <Notification
          key={updateArticulo.code}
          mostrar={updateArticulo.success ? true : false}
          msg={updateArticulo.message}
          stt={updateArticulo.success}
        />
      );
    }
  }

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <div className={classes.sections}>
          <div className={classes.sectionWhite}>
            <div>
              <div className={classes.container}>
                {seccionTitulo}
                <div className={classes.marginTop35}>{seccionFormulario}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default withRouter(ArticuloEdt);
